const SUBROUTES = Array.isArray(process.env.SUBROUTES) ? process.env.SUBROUTES : [];

const initialState = {
  results: null,
  templates: {},
  edges: {},
  descriptions: {},
  searching: false,
  selected: {},
  selectedDetails: null,
  sorts: {},
  resultsMode: "table",
  recordDetailsLoading: false,
  userOwnsSelectedRecord: null,
  selectedRecordHasOwners: null,
  activeCategory: null,
  searchValueCache: SUBROUTES.reduce((obj, r) => ({...obj, [r.parameter]: ''}), {}),
  searchError: {},
  stales: SUBROUTES.reduce((obj, r) => ({...obj, [r.parameter]: false}), {})
}

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "@@SEARCH_RESET_STATE":
      return initialState
    case "@@SEARCH_SET_RESULTS":
      return {
        ...state,
        results: {...state.results, [action.category]: action.results.rows},
        templates: {...state.templates, [action.category]: action.results.template},
        searchValueCache: {...state.searchValueCache, [action.category]: action.searchValue},
        edges: {...state.edges, [action.category]: action.results.edge},
        stales: {...state.stales, [action.category]: false}
      };
    case "@@SEARCH_SET_ACTIVE_CATEGORY":
      return {
        ...state,
        activeCategory: action.category
      }
    case "@@SEARCH_SELECT_ROW":
      return {...state, selected: {...state.selected, [action.category]: state.selected[action.category] !== action.recordId ? action.recordId : null}}
    case "@@SEARCH_SET_SELECTED_DETAILS":
      return {...state, selectedDetails: action.details}
    case "@@SEARCH_SET_RESULTS_MODE":
      return {...state, resultsMode: action.mode}
    case "@@SEARCH_TOGGLE_SEARCHING":
      return {...state, searching: action.searching}
    case "@@SEARCH_SET_SELECTED_OWNERSHIP_RECORDS":
      return {...state, selectedOwnershipRecords: action.selectedOwnershipRecords}
    case "@@SEARCH_SET_RECORD_DETAILS_LOADING":
      return {...state, recordDetailsLoading: action.loading}
    case "@@SEARCH_SET_USER_OWNS_SELECTED_RECORD":
      return {...state, userOwnsSelectedRecord: action.isOwner}
    case '@@SEARCH_SET_SELECTED_RECORD_HAS_OWNERS':
      return {...state, selectedRecordHasOwners: action.hasOwners}
    case '@@SEARCH_SET_SORT':
      return {...state, sorts: {...state.sorts, [action.category]: {sortBy: action.sortBy, sortByDirection: action.sortByDirection}}}
    case '@@SEARCH_SET_DESCRIPTION':
      return {...state, descriptions: {...state.descriptions, [action.category]: action.description}}
    case '@@SEARCH_SET_SEARCH_ERROR': {
      const {[action.category]: deletedResults, ...results} = (state.results || {});
      const {[action.category]: deletedTemplates, ...templates} = state.templates;
      const {[action.category]: deletedSearchValueCache, ...searchValueCache} = state.searchValueCache;
      const {[action.category]: deletedEdges, ...edges} = state.edges;
      return {
        ...state,
        searchError: {...state.searchError, [action.category]: action.searchError},
        results,
        templates,
        searchValueCache,
        edges
      }
    }
    case '@@SEARCH_CLEAR_SEARCH_ERROR':
      return {...state, searchError: {...state.searchError, [action.category]: null}}
    case '@@SEARCH_INVALIDATE_CACHE':
      return {
        ...state,
        stales: Object.keys(state.stales).reduce((obj, key) => {
          obj[key] = true;
          return obj;
        }, {}),
        selected: {}
      }
    default:
      return state;
  }
}

export default searchReducer;



// WEBPACK FOOTER //
// ./src/components/Search/searchReducer.js